document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');

  if (header) {
    const observer = new MutationObserver((mutations) => {
      const anyActive = !!document.querySelector('.modal.is-active[data-modal]');
      header.style.zIndex = anyActive ? '0' : '';
    });

    document.querySelectorAll('.modal[data-modal]').forEach((modal) => {
      observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
    });
  }

  document.querySelectorAll('.navigation__item a[href]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.stopPropagation();
      window.location.href = link.href;
    });
  });

})

class AddCartPanel extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this._onVariantChange.bind(this));
  }

  _onVariantChange(e) {
    if (e.target.name !== 'id') return;
    const label = this.querySelector(`label[for="${e.target.id}"]`);
    if (!label || !label.dataset.price) return;
    this.querySelectorAll('[data-product-price]').forEach(el => {
      el.textContent = label.dataset.price;
    });
  }
}

if (!customElements.get('add-cart-panel')) {
  customElements.define('add-cart-panel', AddCartPanel);
}